<!-- 查看多对多关联数据弹窗 -->
<template>
  <el-dialog
    ref="relateDialog"
    :title="source.title"
    :visible.sync="dialogShow"
    v-if="!disabled">
    <el-table
      :data="tableData"
      ref="selectTable">
      <el-table-column
        v-for="field in visibleFields"
        :prop="field.field_name"
        :label="field.show_name">
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
  /**
   * @param Object source 源数据信息
   */
  import http from '../../../../assets/js/http'
  
  export default {
    props: {
      source: Object
    },
    data() {
      return {
        visibleFields: [],
        tableData: [], // 选择列表
        dialogShow: true
      }
    },
    methods: {
      /**
       * 获取配置和数据
       */
      getData() {
        let params = {
          field_name: this.source.field_name,
          ids: this.source.ids,
          list_id: this.source.list_id
        }
        return this.apiPost(this.source.url, params).then((res) => {
          if (res.code == 200) {
            this.visibleFields = res.data.display_fields
            this.tableData = res.data.list
          } else {
            _g.dealError(this, res)
          }
        })
      },
      /**
       * 打开选择弹窗
       */
      open() {
        this.getData()
        this.$refs.relateDialog.open()
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// relateDeal.vue?d240d7ec